import React, { useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { animated, useSpring } from "@react-spring/web";
import { BaseProps } from "../common/BaseProps";
import { getOtherProperties } from "../common/Utils";

export interface CollapseProps extends BaseProps {
  in?: boolean;
  springConfig?: {
    stiffness?: number;
    damping?: number;
  };
  onEnter?: () => void;
  onLeave?: () => void;
}

export interface CollapseState {
  expanded?: boolean;
}

export default function Collapse(props: CollapseProps) {
  const {
    children,
    className,
    onEnter,
    onLeave,
    springConfig = {
      stiffness: 170,
      damping: 26,
    },
    ...other
  } = props;
  const wrapper = useRef(null);
  const [height, setHeight] = useState(0);

  const measureHeight = () => {
    let collapsedHeight = 0;
    if (wrapper.current) {
      const elem = wrapper.current as HTMLDivElement;
      const overflow = elem.style.overflow;
      elem.style.height = "1px";
      elem.style.overflow = "auto";
      collapsedHeight = elem.scrollHeight;
      elem.style.overflow = overflow;
      elem.style.height = "0";
    }
    return collapsedHeight;
  };

  const styles = useSpring({
    from: {
      height: 0,
    },
    to: {
      height,
    },
    reverse: !props.in,
  });
  const styleClass = classNames("bm-Collapse", className);
  const otherProps = getOtherProperties(other, ["in", "springConfig"]);

  useEffect(() => {
    setHeight(measureHeight());
  }, []);

  return (
    <div className={styleClass} {...otherProps}>
      <animated.div ref={wrapper} style={styles}>
        {children}
      </animated.div>
    </div>
  );
}
